// eslint-disable-next-line import/no-extraneous-dependencies
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import Big from 'big.js';
import { getSalesType, specialsLogger } from 'shared/helpers/specials';
import { getProductWeight } from 'shared/helpers/products';
import { majorityCalculationMethod } from '@dutchie/common/utils/calculation-method';
// this function used to live in /bogo/common.js but that caused a circular dependency reference
export var getBogoIndividualDiscount = function(reward, individualPrice) {
    if (reward === null || reward === void 0 ? void 0 : reward.dollarDiscount) {
        var dollarDiscount = Big(reward.dollarDiscount || 0);
        // If the dollar discount would exceed the price of the item, return the price of the item as the discount instead
        return individualPrice.minus(dollarDiscount).gt(0) ? dollarDiscount : individualPrice;
    }
    if ((reward === null || reward === void 0 ? void 0 : reward.targetPrice) && Big(reward.targetPrice).lt(individualPrice)) {
        var discount = individualPrice.minus(Big(reward.targetPrice || 0));
        return discount.gt(0) ? discount : Big(0);
    }
    return individualPrice.times(Big((reward === null || reward === void 0 ? void 0 : reward.percentDiscount) || 0).div(100));
};
/*
  anytime we have a discount that is not percentage based, we want to spread
  that discount evenly over each of the products in the cart. The leftOver value
  represents the fractional cents left over from floating point math and
  we want to roll that into the next product so we don't lose them
 */ export var amortizeDollarDiscount = function(couponOrReward, leftOver, applicableSubtotal, compositePrice) {
    // Take the proportional amount.  Roll fractional cents forward trying to find a home for them.
    var dollarDiscountApplicable = Big((couponOrReward === null || couponOrReward === void 0 ? void 0 : couponOrReward.dollar) || 0).times(compositePrice).div(applicableSubtotal).plus(leftOver);
    var dollarDiscount = dollarDiscountApplicable.round(2);
    return {
        amortizedDiscount: dollarDiscount,
        leftOver: dollarDiscountApplicable.minus(dollarDiscount)
    };
};
// Works for our case of a non 0 length array containing positive numbers.
var findMaxKey = function(hash) {
    var currentMax = Big(0), currentMaxIndex = -1;
    var keys = _.keys(hash);
    _.forEach(keys, function(key, ind) {
        var val = Big(hash[key]);
        if (Big(val, 'Find Max Key').gte(currentMax)) {
            currentMax = val;
            currentMaxIndex = ind;
        }
    });
    return keys[currentMaxIndex];
};
export function getSpecialSettings(bogoSpecial, globalSpecialSettings) {
    var specialSettings = globalSpecialSettings || {};
    if (bogoSpecial === null || bogoSpecial === void 0 ? void 0 : bogoSpecial.stackingBehavior) {
        specialSettings.stackingBehavior = bogoSpecial.stackingBehavior;
        specialSettings.discountStacking = bogoSpecial.discountStacking;
        specialSettings.nonStackingBehavior = bogoSpecial.nonStackingBehavior;
    }
    if (bogoSpecial === null || bogoSpecial === void 0 ? void 0 : bogoSpecial.discountPrecedence) {
        specialSettings.discountPrecedence = bogoSpecial.discountPrecedence;
    }
    return specialSettings;
}
export var prepareProductTotal = function(details) {
    var __reduce = _.reduce(details, function(accumulator, detail) {
        var _detail_mixAndMatch;
        var productPrice = Big(((_detail_mixAndMatch = detail.mixAndMatch) === null || _detail_mixAndMatch === void 0 ? void 0 : _detail_mixAndMatch.adjustedBasePrice) || detail.basePrice).times(detail.quantity);
        accumulator.productTotal = accumulator.productTotal.add(productPrice.round(2, 1));
        accumulator.productTotalRaw = accumulator.productTotalRaw.add(productPrice);
        return accumulator;
    }, {
        productTotal: Big(0),
        productTotalRaw: Big(0)
    }), productTotal = __reduce.productTotal, productTotalRaw = __reduce.productTotalRaw;
    return {
        productTotal: productTotal,
        residualPrice: productTotalRaw.minus(productTotal)
    };
};
// TODO: this should probably move to ./taxes.js
/*
 * For products where it is obvious what the total is we have to make certain that the pennies
 * line up.  There is not right rounding that makes this work as the following example shows.
 * $2 product containing 37% cannabis tax and 9.9% sales tax with all of this in the POS.
 * So at checkout we compute
 * pre-tax price = 2/(1.37 + .0990) = 1.36147
 * sales-tax = (2/(1.37 + .0990))*1.37 = .50374
 * cannabis-tax = (2/(1.37 + .0990))*0.0990 = .13478
 * 1.36 + .50 + .13 = 1.99
 * A penny shy of our $2 and really obvious to the person who pulled the $2 item off the shelf.
 *
 * If we end up more then 1/2 a cent to redistribute then add the extra cents in unit
 * quantities where there is the largest residual (left over after .01).
 */ export var redistributePennies = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_cannabisTax = _ref.cannabisTax, cannabisTax = _ref_cannabisTax === void 0 ? 0 : _ref_cannabisTax, _ref_salesTax = _ref.salesTax, salesTax = _ref_salesTax === void 0 ? 0 : _ref_salesTax, _ref_price = _ref.price, price = _ref_price === void 0 ? 0 : _ref_price;
    cannabisTax = Big(cannabisTax, 'Redistribute Pennies');
    salesTax = Big(salesTax, 'Redistribute Pennies');
    price = Big(price, 'Redistribute Pennies');
    var residuals = {
        price: price.minus(price.round(2, 0))
    };
    if (!cannabisTax.eq(0)) {
        residuals.cannabis = cannabisTax.minus(cannabisTax.round(2, 0));
    }
    if (!salesTax.eq(0)) {
        residuals.sales = salesTax.minus(salesTax.round(2, 0));
    }
    var residualTotal = _.reduce(_.values(residuals), function(accum, val) {
        return accum.add(val);
    }, Big(0));
    var accountableResidual = residualTotal.round(2, 1);
    var pennies = accountableResidual.times(100);
    delete residuals.price; // We want to count the residual from price but not modify the price.
    var residualRemaining = _.reduce(residuals, function(accum, val) {
        return accum.add(val);
    }, Big(0)).minus(accountableResidual);
    cannabisTax = cannabisTax.round(2, 0);
    salesTax = salesTax.round(2, 0);
    while(pennies.gt(0) && _.keys(residuals).length !== 0){
        var key = findMaxKey(residuals);
        // Divide them across the types of taxes we have available.
        var thisPass = pennies.div(_.keys(residuals).length).round(0, 3);
        // eslint-disable-next-line default-case
        switch(key){
            case 'cannabis':
                cannabisTax = cannabisTax.add(thisPass.times(0.01));
                break;
            case 'sales':
                salesTax = salesTax.add(thisPass.times(0.01));
                break;
        }
        residuals[key] = Big(0);
        pennies = pennies.minus(thisPass);
    }
    // we've consumed the extra pennies through this process.
    return {
        cannabisTax: cannabisTax,
        salesTax: salesTax,
        residual: residualRemaining
    };
};
// this function used to live in ./sales.js but that caused a circular dependency reference
export var getSaleAdjustmentForMenuItem = function(detail) {
    if (!_.isEmpty(detail === null || detail === void 0 ? void 0 : detail.saleAdjustments)) {
        var adjustmentTotal = Big(0);
        _.forEach(detail.saleAdjustments, function(adjustment) {
            var _adjustment_discount;
            var _ref = (adjustment === null || adjustment === void 0 ? void 0 : (_adjustment_discount = adjustment.discount) === null || _adjustment_discount === void 0 ? void 0 : _adjustment_discount.discountData) || {}, discount = _ref.discount, percentDiscount = _ref.percentDiscount, targetPrice = _ref.targetPrice;
            // How much is this item discounted
            var individualDiscount = Big(0);
            if (targetPrice) {
                // Difference between base price and target price
                individualDiscount = Big(detail.menuBasePrice).minus(Big(discount || 0));
            } else if (percentDiscount) {
                // Discount is divided by 100 because the discount is a percentage
                individualDiscount = Big(detail.menuBasePrice).times(Big(discount || 0).div(100));
            } else {
                // Dollar discount means the discount is the discount
                individualDiscount = Big(discount || 0);
            }
            adjustmentTotal = adjustmentTotal.plus(individualDiscount.times(adjustment.count));
        });
        return adjustmentTotal;
    }
    return null;
};
// this function used to live in /bogo/common.js but that caused a circular dependency reference
var getBogoDiscountForMenuItem = function(param) {
    var detail = param.detail, specialsSettings = param.specialsSettings, individualMenuSaleAdjustment = param.individualMenuSaleAdjustment;
    var _detail_bogoSavings;
    var globalStackingBehavior = specialsSettings.stackingBehavior, globalDiscountStacking = specialsSettings.discountStacking;
    var __reduce = _.reduce((detail === null || detail === void 0 ? void 0 : (_detail_bogoSavings = detail.bogoSavings) === null || _detail_bogoSavings === void 0 ? void 0 : _detail_bogoSavings.individual) || [], function(param, savingsObj) {
        var discountTotal = param.discountTotal, itemPrice = param.itemPrice;
        var conditionQuantity = savingsObj.conditionQuantity, isDiscountToCartReward = savingsObj.isDiscountToCartReward, displayAsPercentDiscount = savingsObj.displayAsPercentDiscount, maxApplicable = savingsObj.maxApplicable, individualStackingBehavior = savingsObj.stackingBehavior, individualStackingEnabled = savingsObj.discountStacking;
        var _ref;
        var discountStackingEnabled = (_ref = individualStackingEnabled !== null && individualStackingEnabled !== void 0 ? individualStackingEnabled : globalDiscountStacking) !== null && _ref !== void 0 ? _ref : false;
        var rewardStackingBehaviorIsCumulative = isCumulative(individualStackingBehavior, globalStackingBehavior);
        var totalItemsAddedPastCondition = Math.max(0, detail.quantity - conditionQuantity);
        var discountQuantity = isDiscountToCartReward ? maxApplicable : Math.min(maxApplicable, totalItemsAddedPastCondition);
        var priceToDiscountFrom = Big(detail.menuBasePrice);
        if (discountStackingEnabled && !rewardStackingBehaviorIsCumulative) {
            priceToDiscountFrom = itemPrice;
        }
        var bogoIndividualDiscount = getBogoIndividualDiscount(savingsObj, priceToDiscountFrom);
        var discountAmount = bogoIndividualDiscount.times(discountQuantity);
        if (isDiscountToCartReward) {
            _.set(detail, "bogoSavings.isDiscountToCartReward", true);
            if (displayAsPercentDiscount) {
                _.set(detail, "bogoSavings.displayAsPercentDiscount", true);
            }
        }
        return {
            discountTotal: discountTotal.add(discountAmount),
            itemPrice: itemPrice.minus(discountAmount.div(detail.quantity))
        };
    }, {
        discountTotal: Big(0),
        itemPrice: Big(detail.menuIndividualPrice).add(individualMenuSaleAdjustment)
    }), bogoDiscount = __reduce.discountTotal;
    return !_.isNil(bogoDiscount) && bogoDiscount.gt(0) ? bogoDiscount.toFixed(2) : null;
};
export var calculateMenuTotal = function(details, specialsSettings) {
    return _.reduce(details, function(accum, detail) {
        var menuSaleAdjustment = getSaleAdjustmentForMenuItem(detail);
        if (!_.isNil(menuSaleAdjustment)) {
            _.set(detail, "menuSaleAdjustment", menuSaleAdjustment);
        }
        var individualMenuSaleAdjustment = Big(menuSaleAdjustment || 0).div(detail.quantity);
        var menuBogoDiscount = getBogoDiscountForMenuItem({
            detail: detail,
            specialsSettings: specialsSettings,
            individualMenuSaleAdjustment: individualMenuSaleAdjustment
        });
        if (!_.isNil(menuBogoDiscount)) {
            _.set(detail, "bogoSavings.menuBogoDiscount", menuBogoDiscount);
        }
        return accum.add(Big(detail.menuPrice || 0).add(menuSaleAdjustment || 0).minus(menuBogoDiscount || 0));
    }, Big(0));
};
export var getOfferRewardDiscountType = function(offerReward) {
    if (offerReward.dollarDiscount) {
        return 'dollarDiscount';
    }
    if (offerReward.targetPrice) {
        return 'targetPrice';
    }
    // default to percent discount
    return 'percentDiscount';
};
export var getSaleDiscountType = function(saleSpecial, product) {
    var saleDiscount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var discountType;
    // 3.5 specials should have saleDiscount and discountType defined
    if ((saleDiscount === null || saleDiscount === void 0 ? void 0 : saleDiscount.discountType) && !_.isNil(saleDiscount.discountType)) {
        var discountTypeHash = {
            dollarDiscount: 'dollarDiscount',
            targetPrice: 'targetPrice',
            percentDiscount: 'percentDiscount',
            // i think these are just early enum typos?
            // AMOUNTOFF: 'dollarDiscount',
            // DISCOUNTEDPRICE: 'targetPrice',
            // PERCENTDISCOUNT: 'percentDiscount',
            // these are defined over on the dart calcs side
            AMOUNT_OFF: 'dollarDiscount',
            DISCOUNTED_PRICE: 'targetPrice',
            PERCENT_OFF: 'percentDiscount'
        };
        return discountTypeHash[saleDiscount.discountType];
    }
    // < 3.5 specials - Check for blended sale discount types
    if (product && !_.isEmpty(saleSpecial.specialRestrictions)) {
        var salesType = getSalesType(product);
        // eslint-disable-next-line consistent-return
        _.forEach(saleSpecial.specialRestrictions, function(restriction, key) {
            var _key_split;
            var enterpriseKey = (key === null || key === void 0 ? void 0 : key.startsWith('EPID_')) ? (_key_split = key.split('EPID_')) === null || _key_split === void 0 ? void 0 : _key_split[1] : key;
            if (_.includes(salesType, key) || _.includes(salesType, enterpriseKey)) {
                discountType = restriction === null || restriction === void 0 ? void 0 : restriction.discountType;
                return false; // break early
            }
        });
    }
    if (!discountType) {
        discountType = 'percentDiscount';
        if (saleSpecial.dollarDiscount) {
            discountType = 'dollarDiscount';
        } else if (saleSpecial.targetPrice) {
            discountType = 'targetPrice';
        }
    }
    return discountType;
};
export var sortSpecials = function(specials, product) {
    return _.sortBy(specials, function(special) {
        var specialKey = special.sourceId || special.specialId || special._id;
        var specialTypeKey = special.specialType === 'bogo' ? 1 : 0;
        var stackingKey = (special === null || special === void 0 ? void 0 : special.stackingMode) === 'stacking' || special.discountStacking === true ? 1 : 0;
        var saleDiscount = _.find(special.saleDiscounts, function(sale) {
            return _.includes(sale.productIds, product._id);
        });
        var discountType = specialTypeKey === 1 ? getOfferRewardDiscountType(special) : getSaleDiscountType(special, product, saleDiscount);
        var discountKey = 1; // percent discounts
        if (discountType === 'dollarDiscount') {
            discountKey = 0;
        } else if (discountType === 'targetPrice') {
            discountKey = 2;
        }
        return "".concat(specialTypeKey, "_").concat(stackingKey, "_").concat(discountKey, "_").concat(specialKey);
    });
};
export var findAPlaceForResidualPennies = function(avoidTaxes, productTotal, residualPrice, cannabisTaxTotal, salesTaxTotal, receipt) {
    /*
   * Since we do taxes on a product by product basis we end up with bits of pennies between
   * products that might add up in the end.  If we didn't try to break out taxes and have
   * products which can be on special and have those taxes taken at various points then we
   * could just compute a total and take any odd pennies not directly associated with a product
   * and apply them.  But with our varying treatment of when taxes are shown and how specials are
   * dealt with we just keep track of the residuals and add them back here.
   *
   * Note we should probably really distribute whatever extra pennies we have proportionally between
   * sales and excise tax.  There really shouldn't be more then +/- 1 so just tack it onto the cannabis
   * tax which is likely to be the largest one anyways.
   */ if (avoidTaxes) {
        // If we are in the odd taxesFirst and we have taxes on the menu case then we don't
        // have separate taxes.  Just add them to the product total.
        productTotal = productTotal.add(residualPrice.round(2, 1));
    } else {
        // Don't create a tax category by adding a bit of residual to 0.
        // eslint-disable-next-line no-lonely-if
        if (cannabisTaxTotal.gt(0)) {
            cannabisTaxTotal = cannabisTaxTotal.add(residualPrice.round(2, 1));
        } else if (salesTaxTotal.gt(0)) {
            salesTaxTotal = salesTaxTotal.add(residualPrice.round(2, 1));
        }
    // If we couldn't find a place for it in taxes then stacking it on top of the
    // product total can only create something odd like a product you thought
    // was 48 but came out as 47.99 because of underflow on a discount calculation.
    }
    // Find some taxes to put the residual cents again.  Do this by sorting the
    // taxes and then applying cents from the largest downwards.
    var cents = residualPrice.times(100).round(0);
    if (!cents.eq(0)) {
        var taxValues = _.reverse(_.sortBy(_.filter(_.compact(_.flatMap(receipt.details.products, function(detail) {
            var _detail_taxes, _detail_taxes1;
            return [
                (_detail_taxes = detail.taxes) === null || _detail_taxes === void 0 ? void 0 : _detail_taxes.sales,
                (_detail_taxes1 = detail.taxes) === null || _detail_taxes1 === void 0 ? void 0 : _detail_taxes1.cannabis
            ];
        })), function(val) {
            return !val.eq(0);
        }), function(val) {
            return Number(val);
        }));
        if (taxValues.length > 0) {
            var increment = Number(cents.div(taxValues.length).round(0, 3));
            cents = Number(cents);
            while(cents !== 0){
                var value = taxValues.shift();
                var found = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    for(var _iterator = receipt.details.products[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var product = _step.value;
                        // eslint-disable-next-line no-restricted-syntax
                        for(var _i = 0, _iter = [
                            "cannabis",
                            "sales"
                        ]; _i < _iter.length; _i++){
                            var tax = _iter[_i];
                            product.taxes = product.taxes || {};
                            if (product.taxes[tax] === value) {
                                var amount = Math.min(increment, cents);
                                product.taxes[tax] = product.taxes[tax].plus(amount);
                                cents -= amount;
                                found = true;
                                break;
                            }
                        }
                        if (found) {
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    // Same as above.  If we couldn't find a place for this cent in the taxes then there
    // really isn't a reasonable place to put it.
    }
    return {
        productTotal: productTotal,
        cannabisTaxTotal: cannabisTaxTotal,
        salesTaxTotal: salesTaxTotal
    };
};
export var calculateManualDiscounts = function(manualDiscount, total, receipt) {
    var details = receipt.details, taxConfig = receipt.taxConfig;
    var discountTaxOrder = taxConfig.discountTaxOrder;
    var productTotal = prepareProductTotal(_to_consumable_array(details.products)).productTotal;
    var productTotalInDollars = Big(productTotal, "product total").div(100);
    var newCredit;
    if (manualDiscount.fixedDiscountInCents) {
        var discount = Big(manualDiscount.fixedDiscountInCents, "fixed discount").div(100);
        newCredit = discount.gt(total) ? total : discount;
    } else if (discountTaxOrder !== "discountsFirst" && discountTaxOrder !== "both") {
        newCredit = total.times(Big(manualDiscount.percentDiscount, "manual percent discount").div(100)).round(2, 2);
    } else {
        newCredit = Big(productTotalInDollars).times(Big(manualDiscount.percentDiscount, "manual percent discount").div(100)).round(2, 2);
    }
    receipt.addDiscount({
        type: "manual",
        value: newCredit.times(100)
    });
    return {
        newCredit: newCredit
    };
};
export var isTipEligible = function(param) {
    var paymentMethod = param.paymentMethod, isDelivery = param.isDelivery, dispensary = param.dispensary;
    if ([
        "cash",
        "check"
    ].includes(paymentMethod)) {
        return false;
    }
    if (paymentMethod === "dutchiePay") {
        return !!(dispensary === null || dispensary === void 0 ? void 0 : dispensary.acceptsDutchiePayTips);
    }
    return isDelivery && !!(dispensary === null || dispensary === void 0 ? void 0 : dispensary.acceptsTips);
};
export var calculateTip = function(shouldApplyTip, tipValue, negativePosttaxSubtotal, altBasisForZeroedSubtotal, posttaxSubtotal) {
    var tip = Big(0);
    if (shouldApplyTip) {
        if (_.isArray(tipValue)) {
            var ref;
            ref = _sliced_to_array(tipValue, 1), tipValue = ref[0], ref;
        }
        if (tipValue.percent) {
            // Use product total instead of subtotal, if a discount has brought the subtotal to a negative
            // value and we zeroed it above.
            tip = Big(tipValue.percent, 'Tip Value Percent').times(negativePosttaxSubtotal ? altBasisForZeroedSubtotal : posttaxSubtotal);
        } else if (tipValue.dollar) {
            tip = Big(tipValue.dollar, 'Tip Value Dollar');
        }
    }
    return tip.lt(0) ? Big(0) : tip;
};
export var calculatePostTaxSubtotal = function(productTotal, salesTaxTotal, cannabisTaxTotal, bottleDepositTaxCentsTotal, credit) {
    var posttaxSubtotal = productTotal.plus(salesTaxTotal).plus(cannabisTaxTotal).plus(bottleDepositTaxCentsTotal.div(100)).minus(credit);
    // handle edge case where a coupon discounts that exceed the subtotal results in a negative subtotal
    var negativePosttaxSubtotal = posttaxSubtotal.lt(0);
    if (negativePosttaxSubtotal) {
        posttaxSubtotal = new Big(0);
    }
    return {
        posttaxSubtotal: posttaxSubtotal,
        negativePosttaxSubtotal: negativePosttaxSubtotal
    };
};
export var orderProductsForDiscountBehavior = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], specialsSettings = arguments.length > 1 ? arguments[1] : void 0;
    var discountStacking = specialsSettings.discountStacking, stackingBehavior = specialsSettings.stackingBehavior, nonStackingBehavior = specialsSettings.nonStackingBehavior;
    var discountBehavior = discountStacking ? stackingBehavior : nonStackingBehavior;
    if (!discountBehavior) {
        // this will be hit when an individual special has no discount behavior
        // in that case we want to preserve the order for later calcs
        return products;
    }
    // the order of the products will determine which is discounted so if favor customer
    // is enabled we want the most expensive products first and so the larger discount will
    // be applied
    return _.sortBy(products, function(param) {
        var _param_menuIndividualPrice = param.menuIndividualPrice, menuIndividualPrice = _param_menuIndividualPrice === void 0 ? 0 : _param_menuIndividualPrice;
        return discountBehavior === 'favorCustomer' ? -Number(menuIndividualPrice) : Number(menuIndividualPrice);
    });
};
export var orderProductsForDiscountPrecedence = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], specialsSettings = arguments.length > 1 ? arguments[1] : void 0, context = arguments.length > 2 ? arguments[2] : void 0;
    var discountPrecedence = specialsSettings.discountPrecedence;
    if (!discountPrecedence) {
        // this will be hit when an individual special has no discount precedence
        // in that case we want to preserve the order for later calcs
        return products;
    }
    if (context === 'rewards') {
        return _.sortBy(products, function(param) {
            var _param_menuIndividualPrice = param.menuIndividualPrice, menuIndividualPrice = _param_menuIndividualPrice === void 0 ? 0 : _param_menuIndividualPrice;
            return discountPrecedence === 'highToLow' || discountPrecedence === 'mostExpensiveItem' ? -Number(menuIndividualPrice) : Number(menuIndividualPrice);
        });
    }
    // context === 'conditions'
    return _.sortBy(products, function(param) {
        var _param_menuIndividualPrice = param.menuIndividualPrice, menuIndividualPrice = _param_menuIndividualPrice === void 0 ? 0 : _param_menuIndividualPrice;
        return discountPrecedence === 'highToLow' || discountPrecedence === 'mostExpensiveItem' ? Number(menuIndividualPrice) : -Number(menuIndividualPrice);
    });
};
export var getGlobalSpecialsSettings = function(dispensary) {
    if (_.isNil(dispensary.specialsSettings)) {
        return {
            discountBehavior: 'compounding',
            discountStacking: true,
            discountPrecedence: 'highToLow',
            stackingBehavior: 'compounding',
            nonStackingBehavior: 'favorCustomer'
        };
    }
    var specialsSettings = dispensary.specialsSettings;
    var stackingBehavior = specialsSettings.discountStacking === true ? specialsSettings.stackingBehavior || specialsSettings.discountBehavior : 'cumulative'; // 'cumulative' is the default when discount stacking is disabled
    var nonStackingBehavior = dispensary.specialsSettings.discountStacking === false ? specialsSettings.nonStackingBehavior || specialsSettings.discountBehavior : specialsSettings.nonStackingBehavior || 'favorCustomer'; // 'favorCustomer' is the default
    var discountPrecedence = specialsSettings.discountPrecedence || (nonStackingBehavior === 'favorCustomer' ? 'highToLow' : 'lowToHigh');
    return {
        discountBehavior: specialsSettings.discountBehavior,
        stackingBehavior: stackingBehavior,
        nonStackingBehavior: nonStackingBehavior,
        discountStacking: specialsSettings.discountStacking,
        discountPrecedence: discountPrecedence
    };
};
export var isCumulative = function(individualStackingBehavior, globalStackingBehavior) {
    if (individualStackingBehavior) {
        return individualStackingBehavior === 'cumulative';
    }
    return globalStackingBehavior === 'cumulative';
};
export var getRemainingRewardsQuantity = function(bogoRewards) {
    return _.reduce(bogoRewards, function(obj, curr) {
        if (!obj.total) {
            obj.total = 0;
        }
        var _curr_quantity;
        obj.total += (_curr_quantity = curr.quantity) !== null && _curr_quantity !== void 0 ? _curr_quantity : 0;
        if (!obj[curr._id]) {
            obj[curr._id] = 0;
        }
        var _curr_quantity1;
        obj[curr._id] += (_curr_quantity1 = curr.quantity) !== null && _curr_quantity1 !== void 0 ? _curr_quantity1 : 0;
        return obj;
    }, {});
};
export var compareRewards = function(satisfiers, inProgress) {
    var fullySatisfiedReward = null; // reward_id/key
    var newSatisfiers = _.cloneDeep(satisfiers);
    _.forEach(inProgress, function(reward, rewardId) {
        if (reward.satisfied && !fullySatisfiedReward) {
            fullySatisfiedReward = rewardId;
        }
    });
    if (!fullySatisfiedReward && !_.isEmpty(inProgress)) {
        var ref;
        // pick satisfiers of first product. (already ordered for precedence)
        ref = _sliced_to_array(_.keys(inProgress), 1), fullySatisfiedReward = ref[0], ref;
    }
    // We have the ID of the winning reward,
    // We will loop through the satisfiers/items.rewards for that key and remove others,
    // if the rewards object is empty then I remove the satisfier
    _.forEach(newSatisfiers, function(item, itemId) {
        newSatisfiers[itemId] = _object_spread_props(_object_spread({}, newSatisfiers[itemId]), {
            rewards: _object_spread({}, _.pick(newSatisfiers[itemId].rewards, fullySatisfiedReward))
        });
        if (_.isEmpty(newSatisfiers[itemId].rewards)) {
            delete newSatisfiers[itemId];
        }
    });
    return newSatisfiers;
};
export var logWholesaleDiscount = function(param) {
    var calculationsLogger = param.calculationsLogger, credit = param.credit;
    var wholesaleDiscount = Number(credit);
    if (wholesaleDiscount > 0) {
        var logMessage = "Wholesale discount from ".concat(calculationsLogger ? 'server' : 'client');
        var logData = {
            wholesaleDiscount: wholesaleDiscount
        };
        specialsLogger({
            logger: calculationsLogger,
            data: {
                message: logMessage,
                data: logData
            }
        });
    }
};
/**
 *
 * @param {MapperLineItem} cart
 * @param {string} deliveryOption
 * @param {boolean} medicalOrder
 * @param userPosId
 * @param dispensary_id
 * @returns {{customerTypeId: (number), isDelivery: boolean, cart: *[]}}
 */ export var mapInputsForPriceCartAPI = function(param) {
    var cart = param.cart, _param_address = param.address, address = _param_address === void 0 ? {} : _param_address, deliveryOption = param.deliveryOption, medicalOrder = param.medicalOrder, userId = param.userId, dispensaryId = param.dispensaryId, paymentMethod = param.paymentMethod, couponCode = param.couponCode, appliedRewards = param.appliedRewards, loyaltyPointsApplied = param.loyaltyPointsApplied, deliveryScheduleType = param.deliveryScheduleType, payerId = param.payerId, posCustomerId = param.posCustomerId, preOrderType = param.preOrderType, platformType = param.platformType;
    var cartItems = [];
    var rewardRedemptions = _.compact(_.map(appliedRewards, function(reward) {
        return reward === null || reward === void 0 ? void 0 : reward.discountId;
    }));
    var mappedPaymentId = PAYMENT_METHOD_MAPPING[paymentMethod];
    var paymentMethods = mappedPaymentId ? [
        mappedPaymentId
    ] : [];
    // If the selected payment method is not DutchiePay (id: 1), ensure payerId is not sent
    var paymentPayerId = paymentMethods.includes(1) ? payerId : null;
    var isDelivery = deliveryOption === 'delivery';
    var deliveryScheduleId = deliveryScheduleType === 'scheduled' ? 2 : 1;
    _.forEach(cart, function(item) {
        var cartItem = {};
        // We have to check for the equivalent option in product.POSMetaData.children due to the parent/child issue that
        // results as a side effect of MenuConnector's combined ecomm product mapping for multiple weighted POS products
        var childProduct = _.find(item.product.POSMetaData.children || [], {
            option: item.option
        });
        var _childProduct_canonicalID;
        var productId = Number((_childProduct_canonicalID = childProduct === null || childProduct === void 0 ? void 0 : childProduct.canonicalID) !== null && _childProduct_canonicalID !== void 0 ? _childProduct_canonicalID : item.product.POSMetaData.canonicalID);
        if (!productId) {
            throw new Error("No canonical ID found for product ".concat(item.product.id));
        }
        cartItem.productId = productId;
        cartItem.ecommKey = item.key;
        // packageQuantity means pos packages for that given weight ie: product A: 1g, 2g, 7g would have packageQuantity each of 1, 2, 7 (because 1g is the base weight/package)
        // We check for packageQuantity because that shows it's on a pricing tier, so we multiply the quantity by the package quantity
        cartItem.quantity = (childProduct === null || childProduct === void 0 ? void 0 : childProduct.packageQuantity) ? (childProduct === null || childProduct === void 0 ? void 0 : childProduct.packageQuantity) * item.quantity : item.quantity;
        cartItem.unitPrice = item.basePrice;
        var _childProduct_packageQuantity;
        cartItem.unitWeightGrams = getProductWeight(item.option, 0, 1) / ((_childProduct_packageQuantity = childProduct === null || childProduct === void 0 ? void 0 : childProduct.packageQuantity) !== null && _childProduct_packageQuantity !== void 0 ? _childProduct_packageQuantity : 1);
        cartItems.push(cartItem);
    });
    return {
        cart: cartItems,
        isDelivery: isDelivery,
        deliveryState: address === null || address === void 0 ? void 0 : address.state,
        deliveryCity: address === null || address === void 0 ? void 0 : address.city,
        deliveryPostalCode: (address === null || address === void 0 ? void 0 : address.zipcode) || (address === null || address === void 0 ? void 0 : address.zip),
        deliveryStreet: (address === null || address === void 0 ? void 0 : address.ln1) || (address === null || address === void 0 ? void 0 : address.street1),
        deliveryStreet2: (address === null || address === void 0 ? void 0 : address.ln2) || (address === null || address === void 0 ? void 0 : address.street2),
        ecomUserId: userId,
        customerTypeId: medicalOrder ? 1 : 2,
        dispensaryId: dispensaryId,
        rewardRedemptions: rewardRedemptions,
        paymentMethods: paymentMethods,
        codeRedemptions: couponCode ? [
            couponCode
        ] : [],
        loyaltyPointsApplied: loyaltyPointsApplied,
        deliveryScheduleId: isDelivery ? deliveryScheduleId : null,
        payerId: paymentPayerId,
        posCustomerId: posCustomerId,
        preOrderType: preOrderType,
        platformType: platformType
    };
};
// Builds O(1) lookup indexes for cartItemPrices once per response, instead of re-scanning
// the full array (via _.find/_.filter) for every cart item in getMatchingCartItem.
var buildCartItemPriceIndexes = function() {
    var cartItemPrices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var byEcommKey = new Map();
    var byProductId = new Map();
    _.forEach(cartItemPrices, function(cartItem) {
        if (cartItem.ecommKey && !byEcommKey.has(cartItem.ecommKey)) {
            byEcommKey.set(cartItem.ecommKey, cartItem);
        }
        if (!byProductId.has(cartItem.productId)) {
            byProductId.set(cartItem.productId, []);
        }
        byProductId.get(cartItem.productId).push(cartItem);
    });
    return {
        byEcommKey: byEcommKey,
        byProductId: byProductId
    };
};
var getMatchingCartItem = function(param) {
    var cartItemPriceIndexes = param.cartItemPriceIndexes, item = param.item, logger = param.logger;
    var _item_product_POSMetaData, _item_product;
    // Try to match by ecommKey first
    if (item.key) {
        var ecommKeyMatch = cartItemPriceIndexes.byEcommKey.get(item.key);
        if (ecommKeyMatch) {
            return ecommKeyMatch;
        }
    }
    // Fallback to the old matching logic
    var childProduct = _.find((item === null || item === void 0 ? void 0 : (_item_product = item.product) === null || _item_product === void 0 ? void 0 : (_item_product_POSMetaData = _item_product.POSMetaData) === null || _item_product_POSMetaData === void 0 ? void 0 : _item_product_POSMetaData.children) || [], {
        option: item.option
    });
    if (!childProduct) {
        logger.error("No child product found for product ".concat(item.product.id));
        return undefined; // Skip this item
    }
    var matchingCartItems = cartItemPriceIndexes.byProductId.get(Number(childProduct === null || childProduct === void 0 ? void 0 : childProduct.canonicalID)) || [];
    if (_.isEmpty(matchingCartItems)) {
        logger.error("No matching cart items found for product ".concat(childProduct === null || childProduct === void 0 ? void 0 : childProduct.canonicalID));
        return undefined; // Skip this item
    }
    if (matchingCartItems.length === 1) {
        return matchingCartItems[0];
    }
    var expectedWeight = getProductWeight(item === null || item === void 0 ? void 0 : item.option, 0, 1);
    // Try to find exact weight match first
    var priceCartOutputItem = _.find(matchingCartItems, function(cartItem) {
        if (cartItem.productType === 'Quantity') {
            return Big(cartItem.unitWeightGrams * cartItem.quantity || 0).eq(Big(expectedWeight || 0));
        }
        return Big(cartItem.unitWeightGrams || 0).eq(Big(expectedWeight || 0));
    });
    // If still no match or weight is 0/undefined, use first item as fallback
    if (!priceCartOutputItem) {
        var ref;
        ref = _sliced_to_array(matchingCartItems, 1), priceCartOutputItem = ref[0], ref;
        logger.error("Defaulting to first matching item for product ".concat(childProduct === null || childProduct === void 0 ? void 0 : childProduct.canonicalID, ". ") + "Expected weight: ".concat(expectedWeight, "g, using weight: ").concat(priceCartOutputItem === null || priceCartOutputItem === void 0 ? void 0 : priceCartOutputItem.unitWeightGrams, "g"));
    }
    return priceCartOutputItem;
};
export var updateReceiptFromPriceCartAPI = function(param) {
    var priceCartOutput = param.priceCartOutput, receipt = param.receipt, cartItems = param.cartItems, tipValue = param.tipValue, logger = param.logger, mixAndMatchEnabled = param.mixAndMatchEnabled, _param_roundupForCharityEnabled = param.roundupForCharityEnabled, roundupForCharityEnabled = _param_roundupForCharityEnabled === void 0 ? false : _param_roundupForCharityEnabled;
    var pricingTierTotalPerOrder = Big(0);
    var feeTotals = {
        delivery: Big(0),
        payment: Big(0),
        other: Big(0)
    };
    var discountIncentives = [];
    var rewardDiscount = Big(0);
    var couponOutput = null;
    var credit = Big(0);
    var cartItemPriceIndexes = buildCartItemPriceIndexes(priceCartOutput.cartItemPrices);
    _.forEach(cartItems, function(item) {
        var _item_product_specialData, _item_product_specialData1;
        var priceCartOutputItem = getMatchingCartItem({
            cartItemPriceIndexes: cartItemPriceIndexes,
            item: item,
            logger: logger
        });
        if (!priceCartOutputItem) {
            throw new Error("Price-cart product mismatch: ".concat(item.product.id));
        }
        var discounts = priceCartOutputItem.discounts, summaryPrice = priceCartOutputItem.summaryPrice, menuPrice = priceCartOutputItem.menuPrice, cartPrice = priceCartOutputItem.cartPrice, checkoutPrice = priceCartOutputItem.checkoutPrice, specialCartPrice = priceCartOutputItem.specialCartPrice, specialCheckoutPrice = priceCartOutputItem.specialCheckoutPrice;
        var quantity = item.quantity;
        // The live price-cart lookup can return subtotal: 0 for an item whose underlying DPOS
        // OrderItems row has since been deleted/substituted (e.g. the original product went out of
        // stock and was swapped at the POS) -- that's a "this item no longer resolves" signal, not a
        // legitimate $0 price. Trusting it verbatim on re-validation (e.g. enableLLxSaleDiscountSync)
        // zeroes out the receipt line for a real, non-zero-priced purchase (ECOMM-12102). Fall back to
        // the original submission-time price on the raw cart item when one exists, rather than
        // blindly overwriting it with a zeroed live re-price response.
        // item.basePrice is a per-unit dollar amount (see mapInputsForPriceCartAPI's cartItem.unitPrice
        // = item.basePrice), while priceCartOutputItem.subtotal -- and the whole Receipt -- is in
        // cents. Convert before comparing/substituting so the fallback lands in the right units.
        var liveSubtotal = Big(priceCartOutputItem.subtotal);
        var hasValidOriginalPrice = !_.isNil(item.basePrice) && Big(item.basePrice).gt(0);
        if (liveSubtotal.eq(0) && hasValidOriginalPrice) {
            logger.error("Price-cart returned $0 subtotal for product ".concat(item.product.id, "; falling back to original price"));
        }
        var price = liveSubtotal.eq(0) && hasValidOriginalPrice ? Big(item.basePrice).times(100).times(quantity !== null && quantity !== void 0 ? quantity : 1) : liveSubtotal;
        var basePrice = price.div(quantity !== null && quantity !== void 0 ? quantity : 1);
        var _priceCartOutputItem_pricingTierAdjustmentTotal;
        var pricingTierTotal = Big((_priceCartOutputItem_pricingTierAdjustmentTotal = priceCartOutputItem === null || priceCartOutputItem === void 0 ? void 0 : priceCartOutputItem.pricingTierAdjustmentTotal) !== null && _priceCartOutputItem_pricingTierAdjustmentTotal !== void 0 ? _priceCartOutputItem_pricingTierAdjustmentTotal : 0);
        var originalBasePrice = basePrice.plus(pricingTierTotal.div(quantity !== null && quantity !== void 0 ? quantity : 1));
        // add products to receipt
        var receiptDetail = receipt.addProduct(item.product.id, item.quantity, basePrice, item.option, Big(menuPrice), Big(summaryPrice), cartPrice != null ? Big(cartPrice) : null, checkoutPrice != null ? Big(checkoutPrice) : null, specialCartPrice != null ? Big(specialCartPrice) : null, specialCheckoutPrice != null ? Big(specialCheckoutPrice) : null);
        // Majority vote across this item's discounts so the UI can show "X% off" vs "$X off" without
        // re-deriving it from the raw discounts array. Consumed via getItemPrice/useCartItemDiscount's
        // calculationMethod, which feeds formatDiscountForDisplay's percent-vs-dollar decision.
        receiptDetail.displayAs = majorityCalculationMethod(discounts);
        if (mixAndMatchEnabled) {
            // add pricing tier adjustments to receipt
            pricingTierTotalPerOrder = pricingTierTotalPerOrder.plus(pricingTierTotal);
            receiptDetail.addMixAndMatch({
                type: "originalBasePrice",
                value: originalBasePrice.times(quantity)
            });
            receiptDetail.addMixAndMatch({
                type: "adjustedBasePrice",
                value: basePrice.times(quantity)
            });
            receiptDetail.addMixAndMatch({
                type: "total",
                value: pricingTierTotal
            });
        }
        // add discounts to receipt
        var reducedDiscounts = _.reduce(discounts, function(accum, discount) {
            if (!accum[discount.discountId]) {
                accum[discount.discountId] = discount;
            } else {
                var amount = Big(accum[discount.discountId].amount).add(discount.amount).toFixed(2);
                accum[discount.discountId] = _object_spread_props(_object_spread({}, accum[discount.discountId]), {
                    amount: amount
                });
            }
            return accum;
        }, {});
        var _item_product_specialData_saleSpecials;
        // saleIds/bogoIds only depend on this item's specialData, not on the individual discount, so
        // compute them once per item rather than re-deriving them for every discount below.
        var saleIds = _.map((_item_product_specialData_saleSpecials = (_item_product_specialData = item.product.specialData) === null || _item_product_specialData === void 0 ? void 0 : _item_product_specialData.saleSpecials) !== null && _item_product_specialData_saleSpecials !== void 0 ? _item_product_specialData_saleSpecials : [], 'sourceId');
        var _item_product_specialData_bogoSpecials;
        var bogoIds = _.map((_item_product_specialData_bogoSpecials = (_item_product_specialData1 = item.product.specialData) === null || _item_product_specialData1 === void 0 ? void 0 : _item_product_specialData1.bogoSpecials) !== null && _item_product_specialData_bogoSpecials !== void 0 ? _item_product_specialData_bogoSpecials : [], 'sourceId');
        _.forEach(reducedDiscounts, function(discount) {
            if (discount === null || discount === void 0 ? void 0 : discount.isPaymentIncentive) {
                receiptDetail.addIncentive({
                    type: 'payment',
                    id: discount.discountId,
                    name: discount.name,
                    value: Big(discount.amount)
                });
                discountIncentives.push(discount);
                // Treat payment incentives as order credits as well so they reduce totals
                // while still being displayed as a separate incentive line item.
                credit = credit.plus(discount.amount);
            } else {
                var discountType = getDiscountType({
                    discount: discount,
                    saleIds: saleIds,
                    bogoIds: bogoIds
                });
                if (discountType === 'loyalty') {
                // don't add it up, we do this with the total at the end
                // sometimes the individual items all don't combine to the loyalty total
                } else if (discountType === 'reward') {
                    rewardDiscount = rewardDiscount.plus(Big(discount.amount));
                    receiptDetail.addReward({
                        type: _.toLower(discount.applicationMethod),
                        id: discount.discountId,
                        name: discount.name,
                        value: Big(discount.amount)
                    });
                } else {
                    credit = credit.plus(discount.amount);
                    if ((discount === null || discount === void 0 ? void 0 : discount.applicationMethod) === 'Code') {
                        couponOutput = discount;
                        receiptDetail.addDiscount({
                            type: 'coupon',
                            value: Big(discount.amount),
                            id: discount.discountId,
                            name: discount.name
                        });
                    } else {
                        receiptDetail.addDiscount({
                            value: Big(discount.amount),
                            id: discount.discountId,
                            name: discount.name
                        });
                    }
                }
            }
        });
    });
    if (priceCartOutput.loyaltyAppliedAsDiscount > 0) {
        rewardDiscount.plus(priceCartOutput.loyaltyAppliedAsDiscount);
        receipt.addReward({
            type: 'loyalty',
            id: '',
            name: 'Loyalty',
            value: Big(priceCartOutput.loyaltyAppliedAsDiscount)
        });
    }
    // add fees to receipt
    _.forEach(priceCartOutput.fees, function(fee) {
        var feeAmount = Big(fee.feeAmount, "No Fee Amount for: ".concat(fee.feeName));
        if (fee === null || fee === void 0 ? void 0 : fee.deliveryFee) {
            receipt.addFee({
                type: 'delivery',
                value: feeAmount
            });
            feeTotals.delivery = feeTotals.delivery.plus(feeAmount);
        } else if (fee === null || fee === void 0 ? void 0 : fee.paymentFee) {
            // feePaymentMethod is an id that maps to a payment method 1:dutchie pay, 2:PIN Debit, 3:Credit Card
            receipt.addFee({
                type: 'payment',
                value: feeAmount
            });
            feeTotals.payment = feeTotals.payment.plus(feeAmount);
        } else {
            receipt.addFee({
                type: 'other',
                value: feeAmount
            });
            feeTotals.other = feeTotals.other.plus(feeAmount);
        }
    });
    // add roundup for charity to receipt
    var roundupForCharityAmount = Big(0);
    if (roundupForCharityEnabled) {
        var _priceCartOutput_originalTotal;
        // originalTotal is in cents: convert to dollars, round up, convert back, then calculate difference
        var originalTotal = Big((_priceCartOutput_originalTotal = priceCartOutput === null || priceCartOutput === void 0 ? void 0 : priceCartOutput.originalTotal) !== null && _priceCartOutput_originalTotal !== void 0 ? _priceCartOutput_originalTotal : 0);
        roundupForCharityAmount = originalTotal.div(100).round(0, 3).times(100).minus(originalTotal);
        receipt.addRoundupForCharity({
            type: "checkoutTotal",
            value: roundupForCharityAmount
        });
    }
    var _tipValue_dollar;
    // add tip to receipt
    receipt.addFee({
        type: 'tip',
        value: Big(Math.max((_tipValue_dollar = tipValue === null || tipValue === void 0 ? void 0 : tipValue.dollar) !== null && _tipValue_dollar !== void 0 ? _tipValue_dollar : 0, 0)).times(100)
    });
    // add taxes to receipt
    receipt.addTax({
        type: 'sales',
        value: Big(priceCartOutput.totalSalesTax, "No totalSalesTax")
    });
    receipt.addTax({
        type: 'cannabis',
        value: Big(priceCartOutput.totalCannabisTax, "No totalCannabisTax")
    });
    receipt.addTax({
        type: 'bottleDeposit',
        value: Big(priceCartOutput.totalBottleDepositTax, "No totalBottleDepositTax")
    });
    // Skip transaction rounding if roundup for charity applied
    var transactionRounding = Big(0);
    if (roundupForCharityAmount.eq(0) && priceCartOutput.roundedDifference) {
        var roundingAmount = Big(priceCartOutput.roundedDifference).times(-1);
        receipt.addRounding({
            type: 'transaction',
            value: roundingAmount
        });
        transactionRounding = roundingAmount;
    }
    return {
        pricingTierTotalPerOrder: pricingTierTotalPerOrder,
        feeTotals: feeTotals,
        discountIncentives: discountIncentives,
        rewardDiscount: rewardDiscount,
        couponOutput: couponOutput,
        credit: credit,
        roundupForCharityAmount: roundupForCharityAmount,
        transactionRounding: transactionRounding
    };
};
var getDiscountType = function(param) {
    var discount = param.discount, saleIds = param.saleIds, bogoIds = param.bogoIds;
    if ((discount === null || discount === void 0 ? void 0 : discount.name) === 'Applied Loyalty Points') {
        return 'loyalty';
    }
    if (discount === null || discount === void 0 ? void 0 : discount.isLoyaltyReward) {
        return 'reward';
    }
    if ((discount === null || discount === void 0 ? void 0 : discount.applicationMethod) === 'Code') {
        return 'coupon';
    }
    if (_.includes(saleIds, discount === null || discount === void 0 ? void 0 : discount.discountId.toString())) {
        return 'sale';
    }
    if (_.includes(bogoIds, discount === null || discount === void 0 ? void 0 : discount.discountId.toString())) {
        return 'bogo';
    }
    return 'unknown';
};
var PAYMENT_METHOD_MAPPING = {
    'Pay by Bank': 1,
    dutchiePay: 1,
    debitCard: 2,
    creditCard: 3
};
